import axios from "axios";
import { apiUrl, apiUrl1 } from "./apiUrl";
const apiHandler = async (props) => {
  const { endpoint, method = "GET", options = {}, data, navigation, endpoint2 } = props;

  const headers = {
    ...options,
  };

  
  let url = apiUrl; 
  if (endpoint) {
    url += endpoint;
  } else if (endpoint2) {
    url = apiUrl1 + endpoint2; 
  }

  const axiosObject = {
    method,
    url,
    headers,
    ...(data && { data }),   };


  try {

    const response = await axios(axiosObject);
    return response.data;
  } catch (error) {

    if (error?.response?.status === 401) {
      console.log("Unauthenticated");
    }
    throw error;
  }
};

export default apiHandler;
